import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import FileUpload from "src/components/common/FormComponents/FileUplaod";
// import { setProjectAreaDetails, setStep } from "src/redux/slices/newProject";

import {
  setStep,
  uploadedIds,
  uploadImages,
} from "src/redux/slices/newProjectSetup";

import { useAppSelector } from "src/redux/store";
import { getStyles } from "src/styles/theme";
import FormWrapper from "../FormWrapper";
import defaultStyles, { StylesClasses } from "../NewForms/styles";

export type OrganizationDetailsFormData = {
  geoTaggedImages: {
    type: string;
    key: string;
    file: string;
  }[];
  droneCameraVideo: {
    type: string;
    key: string;
    file: string;
  }[];
};

const ProjectBaselineData = () => {
  const { formData } = useAppSelector(
    (state) => state.root.selectNewProjectSetup
  );

  const fillImages = () => {
    if (formData.uploadedIds.droneCameraVideo.id) {
      return {
        defaultValues: {
          droneCameraVideo: [
            {
              type: "default",
              file: formData.uploadedIds.droneCameraVideo.url,
              key: formData.uploadedIds.droneCameraVideo.id,
            },
          ],
        },
      };
    }
    return {};
  };

  const {
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    trigger,
    formState,
  } = useForm<OrganizationDetailsFormData>({
    mode: "onTouched",
    ...fillImages(),
  });

  const dispatch = useDispatch();

  const { errors, isValid } = formState;
  const styles = getStyles<StylesClasses>(defaultStyles);

  return (
    <FormWrapper
      isValid={isValid}
      onNext={() => {
        const formValues = getValues();
        dispatch(uploadedIds(formValues)); // saves droneCameraVideo; KML already in Redux from ProjectDetails
        dispatch(uploadImages(formValues.geoTaggedImages));
        dispatch(setStep("ProjectGridForm"));
      }}
      onBack={() => {
        dispatch(setStep("ProjectBaselineData"));
      }}
      subHeading={"Please upload the following"}
      currentStepNumber={3}
    >
      <Box {...styles(["input", "fileUpload"])}>
        <FileUpload
          accept="image/jpeg, image/png, image/webp, image/jpg"
          name="geoTaggedImages"
          label="Upload GeoTagged Images (Minimum 2 images are required )"
          control={control}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          setError={setError}
          clearErrors={clearErrors}
          maxLimit={10}
          multiple={true}
          required={true}
          supportedFormatMessage="Supported formats: .jpeg, .png, .webp, .jpg Size Upto 10MB"
          trigger={trigger}
          rules={{
            validate: {
              isLength: (value) => {
                return value && value["length"] >= 2;
              },
            },
          }}
          dragDropHeading=""
        />
      </Box>
      <Box {...styles(["input", "fileUpload"])}>
        <FileUpload
          accept="video/mp4, video/mov, video/avi, video/mkv"
          name="droneCameraVideo"
          label="Upload Drone Camera Video"
          control={control}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          setError={setError}
          clearErrors={clearErrors}
          maxFileSize={300 * 1024 * 1024}
          // maxLimit={10}
          multiple={true}
          supportedFormatMessage="Supported formats: .mp4, .mov, .avi, .mkv Size Upto 200MB"
          trigger={trigger}
          rules={{
            validate: {
              isLength: (value) => {
                return value && value["length"] >= 1;
              },
            },
          }}
          dragDropHeading=""
        />
      </Box>
    </FormWrapper>
  );
};

export default ProjectBaselineData;
